import { useEffect, useState, useRef } from 'react';
import {useInterval, getNowDate, updateUTCDate, commonLogDate, strArraySortDesc, showToast} from '../common/app_common.js';
import {Title, CommonDatePicker} from '../common/component_common.js';
import {DecideWindow} from '../common/modal_common.js';
import {getApiLogQueryRange, getApiLogQueryRangeArray} from '../common/fetch_api/log.js'
import { Button } from 'react-bootstrap';
import '.././common/css/logs.css';
import { BsSearch } from 'react-icons/bs';

const LOG_LIMIT = 5000;
const UPDATE_DELAY = 10;
const PARSE_LEN = 100;

function getStep(from, to)
{
    return Math.max(parseInt((to - from) / LOG_LIMIT), 1);
}

const LogFilter = ({result, saveLog, tableSpinner}) => {

    const [job, setJob] = useState('alert');
    const [severity, setSeverity] = useState('all');
    const [selectMain, setSelectMain] = useState('1');
    const [dateFrom, setDateFrom] = useState(new Date());
    const [dateTo, setDateTo] = useState(new Date());

    const [filterOpt, SetFilterOpt] = useState({job: job, severity: severity, type: selectMain, dateFrom: new Date(), dateTo: new Date()});

    const onChangeJob = (e) => {
        const jobTemp = e.target.value;

        setJob(jobTemp);
        result( {job: jobTemp, severity: severity, type: selectMain, dateFrom: dateFrom, dateTo: dateTo} );
        SetFilterOpt(preState => ({...preState, job: jobTemp}) );
    }

    const onChangeSeverity = (e) => {
        const severityTemp = e.target.value;

        setSeverity(severityTemp);
        result( {job: job, severity: severityTemp, type: selectMain, dateFrom: dateFrom, dateTo: dateTo} );
        SetFilterOpt(preState => ({...preState, severity: severityTemp}) );
    }

    const onChangeMain = (e) => {
        const mainTemp = e.target.value;

        setSelectMain(mainTemp);
        SetFilterOpt(preState => ({...preState, type: mainTemp}) );

        if( mainTemp === 'calendar' )
        {
            const to = new Date();
            const from = new Date(to.getTime() - 3600000);
            setDateFrom(from);
            setDateTo(to);
            
            SetFilterOpt(preState => ({...preState, dateFrom: from, dateTo: to}) );
        }
        else
        {
            result( {job: job, severity: severity, type: mainTemp, dateFrom: dateFrom, dateTo: dateTo} );
        }
    }

    const onChangeFrom = (value) => {
        setDateFrom(value);
        SetFilterOpt(preState => ({...preState, dateFrom: value}) );
    }

    const onChangeTo = (value) => {
        setDateTo(value);
        SetFilterOpt(preState => ({...preState, dateTo: value}) );
    }

    const onClickSaveLog = () => {
        saveLog();
    }

    const onClickSearch = () => {
        const gap = (filterOpt.dateTo.getTime() - filterOpt.dateFrom.getTime())/1000/60/60;
        
        if( gap < 0 )
        {
            showToast("Please verify the search date.", 'warning');
            return;
        }
        else if( gap > 721 )
        {
            showToast(
                <div>
                    <div>{`The search range limit is '721 hours'`}</div>
                    <div>{`You requested over '${parseInt(gap)} hours'`}</div>
                </div>
            , 'warning');
            return;
        }
        
        result(filterOpt);
    }

    return (
        <div className="col-12">
            <div className="d-flex flex-wrap justify-content-end">
                <div className="d-flex mb-2 me-2">
                    <span className="space-text"> Module </span>
                    <select className="form-select form-select-sm" disabled={tableSpinner} onChange={onChangeJob} value={job}>
                        <option value='alert'>Alert</option>
                        <option value='server'>Server</option>
                    </select>
                    <span className="space-text"> Severity </span>
                    <select className="form-select form-select-sm" disabled={tableSpinner} onChange={onChangeSeverity} value={severity}>
                        <option value='all'>All</option>
                        <option value='critical'>Critical</option>
                        <option value='warning'>Warning</option>
                        <option value='info'>Info</option>
                    </select>
                </div>
                <div className="d-flex mb-2">
                    <span className="space-text"> Term </span>
                    <select className="form-select form-select-sm" disabled={tableSpinner} onChange={onChangeMain} value={selectMain}>
                        <option value={"1"}>{"Last 1 hour"}</option>
                        <option value={"6"}>{"Last 6 hour"}</option>
                        <option value={"24"}>{"Last 1 day"}</option>
                        <option value={"168"}>{"Last 1 week"}</option>
                        <option value={"calendar"}>{"Calendar"}</option>
                    </select>
                    <Button variant='primary' className="btn-sm mx-2" onClick={onClickSaveLog}>Save Log</Button>
                </div>
            </div>
            <div className={`d-flex flex-wrap justify-content-end ${selectMain==='calendar'?'':'d-none'}`}>
                <div className="d-flex mb-2">
                    <span className="space-text"> From </span>
                    {/* <SeletorCalendar result={onChangeFrom} label='From' val={dateFrom} disabled={tableSpinner}></SeletorCalendar> */}
                    <CommonDatePicker domId={null} domClass="input-date" state={dateFrom} setState={onChangeFrom} domDisable={tableSpinner}/>
                    <span className="space-text"> To </span>
                    {/* <SeletorCalendar result={onChangeTo} label='To' val={dateTo}disabled={tableSpinner}></SeletorCalendar> */}
                    <CommonDatePicker domId={null} domClass="input-date" state={dateTo} setState={onChangeTo} domDisable={tableSpinner}/>
                    {/* <button type="button" className="btn btn-primary btn-sm" onClick={queryCalendar}><BsSearch /></button> */}
                    <button type="button" className="btn btn-primary btn-sm mx-2" onClick={onClickSearch} disabled={tableSpinner}><BsSearch/></button>
                </div>
            </div>
        </div>
    )
}

const LogList = ({reCount, intv, query, isSave, tableSpinner, setTableSpinner}) => {

    const [result, setResult] = useState(null);
    const [posts, setPosts] = useState(null);
    const [lastTo, setLastTo] = useState(null);
    // const [updateQuery, setUpdateQuery] = useState(null);
    
    const [remainQuery, setRemainQuery] = useState([[]]);
    const [remainIndex, setRemainIndex] = useState(0);
    
    const intvCnt = useRef(1);

    const targetRef = useRef(null);
    const loadTableRef = useRef(false);
    
    function saveLog()
    {
        if( result )
        {
            let writeMsg = `OnAir MapX Log
            \tmodule: ${query.job}
            \tseverity: ${query.severity}
            \t${updateUTCDate(new Date(query.from*1000))} ~ ${updateUTCDate(new Date(query.to*1000))}
            \nLog\n`;
            
            result.forEach( function(post)
            {
                post.forEach( function(txt)
                {
                    writeMsg += txt + '\t';
                });

                writeMsg += '\n';
            });
        
            let filename = commonLogDate() + '_log.txt';
            let element = document.createElement('a');
            element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(writeMsg));
            element.setAttribute('download', filename);
            document.body.appendChild(element);
            element.click();
            element.remove();
        }
    }

    function calcUpdateQuery()
    {
        let countQuery;
        let dataQuery;
        let from;
        let to;
        
        to = parseInt(new Date().getTime()/1000);
        from = lastTo;
        
        const step = getStep(from, to);

        if( query.severity === 'all' )
        {
            countQuery = `count_over_time({job="${query.job}"}[${step}s])`;
            dataQuery = `{job="${query.job}"}`;
        }
        else
        {
            countQuery = `count_over_time({job="${query.job}"}[${step}s] |= "[${query.job}] [${query.severity}]")`;
            dataQuery = `{job="${query.job}"} |= "[${query.job}] [${query.severity}]"`;
        }

        // setUpdateQuery({countQuery: countQuery, dataQuery: dataQuery, from: from, to: to, step: step});
        
        updatePosts({countQuery: countQuery, dataQuery: dataQuery, from: from, to: to, step: step});
        setLastTo(to);
    }

    function getTableData(value)
    {
        const temp = [...value[1].split(' - ')];
        const txt = temp[0].replace(/\[/g, '');
        const arr = [...txt.split(']')].filter( a => a.length > 0 );

        const date = updateUTCDate(new Date(value[0]/1000000));
        arr[0] = date;

        if( arr.length < 3 )
        {
            arr[1] = '';
            arr[2] = '';
            arr[3] = txt;
        }
        // console.log('value', arr, value[0], date, txt);
        return [...arr, temp[1]];
    }

    function getLineClass(item)
    {
        if( item[3].includes('resolved :') )
        {
            return 'text-white';
        }
        else
        {
            if( item[2].includes('info') || item[2].includes('good') )
            {
                return 'text-info';
            }
            else if( item[2].includes('warning') )
            {
                return 'text-warning';
            }
            else if( item[2].includes('error') || item[2].includes('critical') )
            {
                return 'text-error';
            }
        }

        return '';
    }

    function createPosts()
    {
        Promise.resolve( getApiLogQueryRange('forward', LOG_LIMIT, query.countQuery, query.from, query.to, query.step) )
        .then( data => {
            let loadApiArr = [];
            let saveApiArr = [[]];
            let size = 0;
            let saveIdx = -1;
            if( data.data.result.length > 0 )
            {
                const arr = [...data.data.result[0].values].sort((a, b) => strArraySortDesc(a, b));
                
                if( arr.length > 1 )
                {
                    for( let idx=0; idx<arr.length; idx++ )
                    {
                        let from;
                        const to = arr[idx][0];

                        if( idx === arr.length-1 )
                        {
                            from = to - query.step;
                        }
                        else
                        {
                            from = arr[idx+1][0];
                        }

                        const step = getStep(from, to);
                        if( size >= PARSE_LEN )
                        {
                            if(saveIdx !== parseInt(size/PARSE_LEN) - 1)
                            {
                                saveIdx = parseInt(size/PARSE_LEN) - 1;
                                saveApiArr[saveIdx] = [];
                            }
                            // saveApiArr[saveIdx].push(getApiLogQueryRange('forward', LOG_LIMIT, query.dataQuery, from, to, step));
                            saveApiArr[saveIdx].push({direction:'forward', limit:LOG_LIMIT, query:query.dataQuery, start:from, end:to, step:step});
                        }
                        else
                        {
                            // loadApiArr.push(getApiLogQueryRange('forward', LOG_LIMIT, query.dataQuery, from, to, step));
                            loadApiArr.push({direction:'forward', limit:LOG_LIMIT, query:query.dataQuery, start:from, end:to, step:step});
                        }
                        
                        size += parseInt(arr[idx][1]);
                    }
                }
                else
                {
                    const to = arr[0][0];
                    const from = to - query.step;
                    const step = getStep(from, to);

                    // loadApiArr.push(getApiLogQueryRange('forward', LOG_LIMIT, query.dataQuery, from, to, step));
                    loadApiArr.push({direction:'forward', limit:LOG_LIMIT, query:query.dataQuery, start:from, end:to, step:step});
                }
            }

            return {loadApiArr, saveApiArr};
        })
        .then( data => {

            setRemainQuery(data.saveApiArr);
            setRemainIndex(0);

            Promise.resolve( getApiLogQueryRangeArray(data.loadApiArr) )
            .then( data => {
                let result = [];
                data.forEach( (item, idx) => {
                    if( item.data.result && item.data.result.length > 0 )
                    {
                        if( item.data.result[0].values )
                        {
                            const arr = [...item.data.result[0].values].sort((a, b) => strArraySortDesc(a[0], b[0]));
                            for( let value of arr )
                            {
                                result.push(getTableData(value));
                            }
                        }
                        else
                        {
                            const arr = [...item.data.result[0].value[0]].sort((a, b) => strArraySortDesc(a[0], b[0]));
                            result.push(getTableData(arr));
                        }
                    }
                });

                return result;
            })
            .then( result => {
                setResult(result);
                setPosts( result.map( (item, idx) => (
                    // <tr key={idx} className={`text-${item[2].trim(1)}`}>
                    <tr key={idx} className={getLineClass(item)}>
                        <td>{item[0]}</td>
                        <td>{item[1]}</td>
                        <td>{item[2]}</td>
                        <td>{item[3]}</td>
                    </tr>
                )));
                
                setTimeout(() => {setTableSpinner(false);}, 200);
            })
            .catch( e => {
                setPosts(null);
                setTimeout(() => {setTableSpinner(false);}, 200);
            });
        })
        .catch( e => {
            setPosts(null);
            setTimeout(() => {setTableSpinner(false);}, 200);
        });
    }

    function updatePosts(updateQuery)
    {
        setTableSpinner(true);

        Promise.resolve( getApiLogQueryRange('forward', LOG_LIMIT, updateQuery.countQuery, updateQuery.from, updateQuery.to, updateQuery.step) )
        .then( data => {
            let apiArr = [];
            if( data.data.result.length > 0 )
            {
                const arr = data.data.result[0].values;
                if( arr.length > 1 )
                {
                    for( let idx=0; idx<arr.length-1; idx++ )
                    {
                        let from;
                        const to = arr[idx][0];

                        if( idx === 0 )
                        {
                            from = to - updateQuery.step;
                        }
                        else
                        {
                            from = arr[idx-1][0];
                        }
                        const step = getStep(from, to);

                        apiArr.push(getApiLogQueryRange('forward', LOG_LIMIT, updateQuery.dataQuery, from, to, step));
                    }
                }
                else
                {
                    const to = arr[0][0];
                    const from = to - query.step;
                    const step = getStep(from, to);
                    apiArr.push(getApiLogQueryRange('forward', LOG_LIMIT, query.dataQuery, from, to, step));                    
                }
            }

            return apiArr;
        })
        .then( apiArr => {
            
            Promise.all( apiArr )
            .then( data => {
                let result = [];

                if( data )
                {
                    data.forEach( (item, idx) => {
                        if( item.data.result.length > 0 )
                        {
                            if( item.data.result[0].values && item.data.result[0].values.length > 1 )
                            {
                                for( let value of item.data.result[0].values )
                                {
                                    result.push(getTableData(value));
                                }
                            }
                            else
                            {
                                result.push(getTableData(item.data.result[0].values[0]));
                            }
                        }
                    });
                }

                return result;
            })
            .then( result => {
                setPosts( [result.map( (item, idx) => (
                    // <tr key={idx} className={`text-${item[2].trim(1)}`}>
                    <tr key={idx} className={getLineClass(item)}>
                        <td>{item[0]}</td>
                        <td>{item[1]}</td>
                        <td>{item[2]}</td>
                        <td>{item[3]}</td>
                    </tr>
                )), ...posts]);
                
                setTimeout(() => {setTableSpinner(false);}, 200);
            })
            .catch( e => {
                setPosts(null);
                setTimeout(() => {setTableSpinner(false);}, 200);
            });
        })
        .catch( e => {
            setPosts(null);
            setTimeout(() => {setTableSpinner(false);}, 200);
        });
    }

    // useEffect( () => {

    //     if( query )
    //     {
    //         setTableSpinner(true);
    //         setLastTo(intv?query.to:null);
    //         createPosts();
    //     }
    // }, [JSON.stringify(query)]);

    // useEffect( () => {
    //     if(!updateQuery) return ;
        
    //     updatePosts();
        
    // }, [JSON.stringify(updateQuery)]);

    const didMount = useRef(true);
    useEffect( () => {
        
        if( didMount.current )
        {
            didMount.current = false;
        }
        else
        {
            saveLog();
        }
        
    }, [isSave]);

    useEffect( () => {
        intvCnt.current = 1;
        
        if( query )
        {
            targetRef.current.scrollTop = 0;
            setTableSpinner(true);
            setLastTo(intv?query.to:null);
            createPosts();
        }

    }, [reCount]);

    useInterval(() =>
    {
        // console.log('interval', intvCnt.current);
        if( intv )
        {
            if( intvCnt.current >= UPDATE_DELAY )
            {
                intvCnt.current = 0;
                calcUpdateQuery();
            }

            intvCnt.current++;
        }
        else
        {
            intvCnt.current = 0;
        }
    }, 1000 );

    const handleScroll = () => {
        const top = targetRef.current.scrollTop;
        const max = targetRef.current.scrollHeight - targetRef.current.clientHeight;
        // const max = targetRef.current.scrollTopMax;  //표준 속성아님. firefox를 제외한 브라우저에서 오동작

        if( loadTableRef.current === true )
        {
            return;
        }

        let id = setInterval(() => {
            if( targetRef.current !== null )
            {
                if( top === targetRef.current.scrollTop )
                {
                    clearInterval(id);
                    let ratio = top/max;

                    if( !remainQuery[remainIndex] || remainIndex >= remainQuery.length || ratio < 0.7)
                    {
                        return;
                    }

                    setTableSpinner(true);
                    loadTableRef.current = true;
                    
                    // Promise.all(
                    //     remainQuery[remainIndex].map( (item, idx) => (
                    //         getApiLogQueryRange(item.direction,item.limit,item.query,item.start,item.end,item.step)
                    //     ))
                    // )
                    Promise.resolve( getApiLogQueryRangeArray(remainQuery[remainIndex]) )
                    .then( data => {
                        setRemainIndex(remainIndex + 1);
                        let result = [];
                        data.forEach( (item, idx) => {
                            if( item.data.result.length > 0 )
                            {
                                if( item.data.result[0].values )
                                {
                                    for( let value of item.data.result[0].values )
                                    {                                
                                        result.push(getTableData(value));
                                    }
                                }
                                else
                                {
                                    result.push(getTableData(item.data.result[0].value[0]));
                                }
                            }
                        });

                        return result;
                    })
                    .then( result => {
                        setResult((prevState) => [...prevState, ...result]);
                        setPosts([...posts, result.map( (item, idx) => (
                            // <tr key={idx} className={`text-${item[2].trim(1)}`}>
                            <tr key={idx} className={getLineClass(item)}>
                                <td>{item[0]}</td>
                                <td>{item[1]}</td>
                                <td>{item[2]}</td>
                                <td>{item[3]}</td>
                            </tr>
                        ))]);

                        return true;
                    })
                    .then( done => {
                        loadTableRef.current = false;
                        setTimeout(() => {setTableSpinner(false);}, 200);
                    })
                    .catch( e => {
                        setPosts(null);
                        setTimeout(() => {setTableSpinner(false);}, 200);
                    });
                }
            }
        }, 200);
    };

    return (
        <div className="section log-area position-relative">
            {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>DateTime</th>
                        <th>Module</th>
                        <th>Severity</th>
                        <th>Contents</th>
                    </tr>
                </thead>
                <tbody ref={targetRef} onScroll={handleScroll}>
                    {posts}
                </tbody>
            </table>
        </div>
    );
}

const PageLogs = () => {
    
    const [query, setQuery] = useState(null);
    const [intv, setIntv] = useState(false);
    const [saveLog, setSaveLog] = useState(false);
    const [reCount, setReCount] = useState(false);

    const [tableSpinner, setTableSpinner] = useState(false);

    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = () => {
        setModalDecide(true);
    };

    function isSave(is)
    {
        if(is)
        {
            setSaveLog(!saveLog);
        }
    }

    const SetDecideBody = () => {
        return (
            <div className='text-center'>
                <p>Only the logs that you scrolled through will be saved. Do you want to save the logs?</p>
            </div>
    )};

    const parseResult = (filter) => {

        let countQuery;
        let dataQuery;
        let from;
        let to;
        let intv = false;
        
        if( filter.type === 'calendar' )
        {
            to = parseInt(filter.dateTo.getTime()/1000);
            from = parseInt(filter.dateFrom.getTime()/1000);
        }
        else
        {
            if( filter.type === '1' )
            {
                intv = true;
            }

            to = parseInt(new Date().getTime()/1000);
            from = to - (parseInt(filter.type) * 60 * 60);
        }
        
        const step = getStep(from, to);

        if( filter.severity === 'all' )
        {
            countQuery = `count_over_time({job="${filter.job}"}[${step}s])`;
            dataQuery = `{job="${filter.job}"}`;
        }
        else
        {
            countQuery = `count_over_time({job="${filter.job}"}[${step}s] |= "[${filter.job}] [${filter.severity}]")`;
            dataQuery = `{job="${filter.job}"} |= "[${filter.job}] [${filter.severity}]"`;
        }

        setQuery({countQuery: countQuery, dataQuery: dataQuery, from: from, to: to, step: step, job: filter.job, severity: filter.severity});
        setIntv(intv);
        setReCount(!reCount);
    }

    useEffect( () => {
        parseResult( {job: 'alert', severity: 'all', type: '1', dateFrom: new Date(), dateTo: new Date()} );
    }, []);

    return (
        <>
            <div className="d-flex flex-wrap">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <Title title='Logs'></Title>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <LogFilter result={parseResult} saveLog={showModalDecide} tableSpinner={tableSpinner}/>
                </div>
            </div>
            <LogList reCount={reCount} intv={intv} query={query} isSave={saveLog} tableSpinner={tableSpinner} setTableSpinner={setTableSpinner}/>
            {modalDecide&&<DecideWindow result={isSave} show={modalDecide} handleClose={closeModalDecide} body={<SetDecideBody/>} okButtonTxt={'Save'}></DecideWindow>}
        </>
    )
}

export default PageLogs;